/** @jsx jsx */
import {css, jsx} from '@emotion/react';
import { LimitDropdown, LIMIT_TYPES, getLimitValue } from 'components/dropdowns/limitDropdown';
import { useContext, useEffect, useState } from 'react';
import { ColorAliases, Variables as VARIABLES } from 'styles/variables';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';
import { WorkspaceContext } from '/views/workspace/workspaceContext';

export const LimitSelector = ({
	cardIndex,
	initialLimit = LIMIT_TYPES.AUTO,
	autoLimit = null,
	endpointQuery,
	canRenderAuto = true,
	canRenderNoLimit = true,
	limitProperty = 'MaxValues',
	label = 'Item Limit',
  widgetConfiguration,
	...rest
}) => {
	const { dispatch } = useContext(WorkspaceContext);
	const [limitTo, setLimitTo] = useState(initialLimit);

	// If endpointQuery has a value for the limitProperty use that. Don't need to call handleSetLimit
	// because that would update endpointQuery...to what it is already. Just update the local state
	useEffect(() => {
		if (endpointQuery?.options?.parameters) {
			setLimitTo(endpointQuery?.options?.parameters?.[limitProperty])
		}
	}, [endpointQuery]);

	const handleSetLimit = (cardIndex, endpointQuery, value) => {
		setLimitTo(value);
		const options = JSON.parse(JSON.stringify(endpointQuery?.options));
		options.parameters[limitProperty] = getLimitValue(value, autoLimit, null);
		dispatch(WorkspaceActionCreator.options(cardIndex, { options }));
	};


	const dropdownProps = {
		activeLimit: limitTo,
		onLimitChanged: handleSetLimit
	}
	//NOTE: in widget config, widgetConfiguration the name of the options field must follow this convention.
	const options = widgetConfiguration && widgetConfiguration[`${limitProperty}_options`];

	return (
		<div>
			<span css={labelCss}>
				{label}
			</span>

			<LimitDropdown
				{...dropdownProps}
				limit={getLimitValue(limitTo, autoLimit, null)}
				canRenderAuto={canRenderAuto}
				canRenderNoLimit={canRenderNoLimit}
				cardIndex={cardIndex}
				endpointQuery={endpointQuery}
				label={label}
				css={dropDownCss}
				options={options}
				{...rest}
			/>
		</div>
	);
};

//To target the .popover-target would require popoverProps={{targetProps: {css : dropDownCss}}}. That doesn't work
//because it "stringifies" the dropDownCss prop. This way gets us around that.
const dropDownCss = css`
	& > span {
		width: 100%;
	}
`;

const labelCss = css`
	margin-bottom: 0;
	font-family: ${VARIABLES.PT_FONT_FAMILY};
	font-size: ${VARIABLES.PT_FONT_SIZE};
	color: ${ColorAliases.PT_HEADING_COLOR};
	font-weight: normal;
`;
